export default __webpack_public_path__ + "static/media/collectButton.c0e0baa3.svg";